<template>
  <li>
    <component
      :is="componentType"
      :href="usingClick ? null : props.href"
      class="block"
      :target="props.external ? '_blank' : null"
      :rel="props.external ? 'noopener noreferrer' : null"
      :class="{
        'hover:bg-gray-50 dark:hover:bg-gray-700': props.href || usingClick,
        'cursor-pointer	': usingClick,
      }"
      @click="handleClick"
    >
      <div class="flex items-center px-4 py-4 sm:px-6">
        <slot />
      </div>
    </component>
  </li>
</template>

<script setup>
import { Link } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'

const props = defineProps({
  href: String,
  external: Boolean,
  onClick: Function,
})

const usingClick = computed(() => props.onClick && !props.href)

const componentType = computed(() => {
  if (!props.href || usingClick.value) return 'div'
  else if (props.external) return 'a'
  else return Link
})

function handleClick(event) {
  if (usingClick.value) {
    event.preventDefault()
    props.onClick(event)
  }
}
</script>
